import LocalCacher from '@/modules/cache/localCacher'

export const setContactBookMutator = (state, payload) => {
  LocalCacher.indexDB.contactBooks.updateTable(payload.data)
}
export const setContactGroupsMutator = (state, payload) => {
  state.contactGroups = payload
}
